module.exports = __webpack_public_path__ + "static/media/bonus-cash-2.cd3d0808.png";